import { gql } from "@apollo/client";

export default gql`
  query getOrganizationConnectedIntegrationTypes($organizationId: Int!) {
    organization(pk: $organizationId) {
      id
      connectedIntegrationTypes
    }
  }
`;
